// Importing 3rd party dependencies
import { create } from 'zustand';
// ----------------------------------------------------------------------
export const usePostStore = create()((set) => ({
    post: undefined,
    setPost: (post) => set(() => ({ post })),
}));
